var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length > 0)?_c('ul',{staticClass:"ui-state-error",attrs:{"role":"alert","aria-atomic":"true","aria-live":"polite"}},_vm._l((_vm.messages),function(message){return _c('validation-message',{key:message.code,attrs:{"message":message}})}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8daed77a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/forms/registration-form/ValidationMessages.vue
// module id = null
// module chunks = 